import { CurrenciesType } from '@constants/currencies'
import useSWR from 'swr'

export type CountriesType = {
  name: string
  iso: string
  is_european_union: boolean
  currency: CurrenciesType
}

export interface GetCountriesResponse {
  countries: CountriesType[]
}

export const useGetCountries = (language: string) =>
  useSWR<GetCountriesResponse>(`payments/countries?lang=${language}`)
